import type { BusinessStripeAccount } from '@barboxx/models/types';
import type Stripe from 'stripe';

import { api } from '../../api';
import * as Customers from './customers';

const rootPath = 'stripe';

export function createAccount(data: BusinessStripeAccount.CreateRequest) {
    return api.post<Stripe.Account>(`${rootPath}/account`, data);
}

export function linkConnectedAccount(data: BusinessStripeAccount.LinkRequest) {
    return api.post<BusinessStripeAccount.LinkResponse>(
        `${rootPath}/account-link`,
        data
    );
}

export function createAccountSession(
    data: BusinessStripeAccount.AccountSessionRequest
) {
    return api.post<BusinessStripeAccount.CreateSessionResponse>(
        `${rootPath}/account-session`,
        data
    );
}

export function getStripeAccount(id: number) {
    return api.get<BusinessStripeAccount.DetailsResponse>(`${rootPath}/${id}`);
}

export { Customers };
